import { Component, OnInit } from '@angular/core';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { AdministrationService } from 'src/app/services/administration/administration.service';


@Component({
  selector: 'app-tc',
  templateUrl: './tc.component.html',
  styleUrls: ['./tc.component.css']
})
export class TcComponent implements OnInit {

  ClassList: any;
  Submitted: boolean = false;
  TCList: any;
  SelectedFileForUpload: any;

  constructor(private adminservice: AdministrationService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  TCModel = {
    TCID: 0,
    FirstName: '',
    ClassID: 0,
    StudentNo: '',
    FilePath: '',
    IsActive: true
  };

  Clear() {

    this.TCModel.TCID = 0;
    this.TCModel.FirstName = '';
    this.TCModel.ClassID = 0;
    this.TCModel.StudentNo = '';
    this.TCModel.FilePath = '';
    this.TCModel.IsActive = false;
    this.Submitted = false;
  };


  GetAllTC() {
    this.spinnerService.show();
    this.adminservice.GetAllTC().subscribe((response: any) => {
      this.TCList = response.TCList;
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(response);
    });
  };

  selectFileforUpload(file) {
    this.SelectedFileForUpload = file[0];
  };



  SaveTC(valid) {
    this.Submitted = true;
    if (valid) {
      this.spinnerService.show();
      this.adminservice.SaveTC(JSON.stringify(this.TCModel), this.SelectedFileForUpload).subscribe((data: any) => {
        if (data.webResponse.Status && this.TCModel.TCID == 0) {
          this.Clear();
        }
        this.Submitted = false;
        this.GetAllTC();
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(data);

      });
    }
  }

  Edit(obj) {

    this.TCModel.TCID = obj.TCID;
    this.TCModel.ClassID = obj.ClassID;
    this.TCModel.FirstName = obj.FirstName;
    this.TCModel.StudentNo = obj.StudentNo;
    this.TCModel.IsActive = obj.IsActive;

  };


  ngOnInit() {

    this.BindClass();
    this.GetAllTC();



  }



  BindClass() {
    this.lookupservice.GetLookupsList('Class', '').subscribe((data: any) => {
      this.ClassList = data.LookupItems;
    });
  };



}





